export const GET_REVIEW_TAGS = "GET_REVIEW_TAGS";
export const CREATE_REVIEW_TAGS = "CREATE_REVIEW_TAGS";
export const UPDATE_REVIEW_TAGS = "UPDATE_REVIEW_TAGS";
export const DELETE_REVIEW_QUOTE = "DELETE_REVIEW_QUOTE";
export const RESET_REVIEW_TAGS = "RESET_REVIEW_TAGS";
export const TOGGLE_IS_SAVED = "TOGGLE_IS_SAVED";
const industryTableWidth = '200px';
const jobTitleTableWidth = '380px';

export const RESEARCH_DASHBOARD_INTERVIEWS_TABLE_HEADERS = [
    { item: 'Industry', sort: true, sortOn: 'industry', styles: { width: industryTableWidth} },
    { item: 'Job title', sort: true, sortOn: 'job_function', styles: { width: jobTitleTableWidth } },
    { item: 'Company size', sort: true, sortOn: 'company_size_key' },
    { item: 'Date', sort: true, sortOn: 'published_date' },
    { item: 'Rating', sort: true, sortOn: 'rating' },
    { item: '', sort: false },
    { item: '', sort: false },
    { item: '', sort: false },
    { item: '', sort: false },
];

export const RESEARCH_DASHBOARD_REFERENCE_CALLS_TABLE_HEADERS = [
    // { item: 'Match (%)', sort: true, sortOn: 'match' },
    { item: 'Industry', sort: true, sortOn: 'industry', styles: { width: industryTableWidth} },
    { item: 'Company size', sort: true, sortOn: 'company_size_key' },
    { item: 'Job title', sort: true, sortOn: 'job_function', styles: { width: jobTitleTableWidth } },
    { item: '', sort: false },
    { item: '', sort: false },
];

export const RESEARCH_DASHBOARD_PEER_REPORTS_TABLE_HEADERS = [
    { item: 'Type' },
    { item: 'Title' },
    { item: 'Industry' },
    { company_size: 'Company size' },
    { date: 'Date' },
    { item: '' }
];

export const RESEARCH_DASHBOARD_DOWNLOAD_REPORTS_TABLE_HEADERS = [
    { item: 'Type' },
    { item: 'Title' },
    { item: 'Last updated' },
    { item: '' }
];

export const SENTIMENT_SCORE_TOOLTIP = "The sentiment score, rated on a 1-10 scale, is analyzed by the " +
  "PeerSpot team, while the rating is chosen by the reviewer. Keep in mind, sentiment scores can be influenced by " +
  "sarcasm, irony, or ambiguous responses.";